import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

export interface CreatePersonalAccountBody {
  user_id: number;
  currency: string;
  alias?: string;
  mode?: 'create' | 'upgrade';
  accepted_costs: true;
  provider_id?: number;
  provider_service_id?: number;
  verification_type?: 'kyc' | 'kyb';
  soft_kyc?: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class PersonalAccountsService {
  constructor(private http: HttpService) {}

  list(userId?: number | string): Observable<any> {
    let params = new HttpParams();
    if (userId != null && userId !== '') {
      params = params.set('user_id', String(userId));
    }
    params = params.set('page_size', '100');
    return this.http.get('personal-accounts', params);
  }

  getCosts(
    currency: string,
    userId?: number | string,
    opts?: { providerId?: number; providerServiceId?: number },
  ): Observable<any> {
    let params = new HttpParams().set('currency', String(currency || '').toUpperCase());
    if (userId != null && userId !== '') {
      params = params.set('user_id', String(userId));
    }
    if (opts?.providerId != null) {
      params = params.set('provider_id', String(opts.providerId));
    }
    if (opts?.providerServiceId != null) {
      params = params.set('provider_service_id', String(opts.providerServiceId));
    }
    return this.http.get('personal-accounts/costs', params);
  }

  create(body: CreatePersonalAccountBody): Observable<any> {
    return this.http.post('personal-accounts', body);
  }
}

export function personalAccountApiError(err: any, fallback: string): string {
  if (!err) return fallback;
  if (typeof err === 'string') return err;
  return (
    err.error ||
    err.message ||
    err.detail ||
    err?.identity_incomplete?.message ||
    fallback
  );
}
